
import { supabase } from '@/integrations/supabase/client';

export interface Position {
  id: string;
  name: string;
  description?: string;
  parentId?: string; // Frontend uses camelCase
  created_at: string;
}

export const getPositions = async (): Promise<Position[]> => {
  try {
    const { data, error } = await supabase
      .from('positions')
      .select('*')
      .order('name');

    if (error) {
      console.error('Error fetching positions:', error);
      return [];
    }

    return (data || []).map((item: { id: string; name: string; description?: string; parent_id?: string; created_at: string }) => ({
      id: item.id,
      name: item.name,
      description: item.description,
      parentId: item.parent_id, // Convert snake_case to camelCase for frontend
      created_at: item.created_at
    }));
  } catch (error) {
    console.error('Exception fetching positions:', error);
    return [];
  }
};

export const getPositionById = async (id: string): Promise<Position | null> => {
  try {
    const { data, error } = await supabase
      .from('positions')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      console.error('Error fetching position:', error);
      return null;
    }

    return {
      id: data.id,
      name: data.name,
      description: data.description,
      parentId: data.parent_id, // Convert snake_case to camelCase for frontend
      created_at: data.created_at
    };
  } catch (error) {
    console.error('Exception fetching position:', error);
    return null;
  }
};
